// extracted by mini-css-extract-plugin
export var askAiIcon = "_s7-9";
export var container = "_s7-0";
export var groupSeparator = "_s7-a";
export var highlight = "_s7-4";
export var resultIcon = "_s7-5";
export var resultItem = "_s7-7";
export var resultSubtitle = "_s7-3";
export var resultTitle = "_s7-2";
export var resultsList = "_s7-1";
export var searchGroup = "_s7-6";
export var selected = "_s7-8";